import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FormNotifcations from "./FormNotifcations";
import FormResetPassword from "./FormResetPassword";
import ShareApp from "./ShareApp";
import SuccessResetPassword from "./SuccessResetPassword";
import SuccessAddDream from "./SuccessAddDream";
import Promo from "./Promo";
import Privacy from "./Privacy";
import Policy from "./Policy";
import Checkout from "./Checkout";
import Payment from "./Payment";
import CurrentOrder from "./CurrentOrder";

// import AddDream from "./Text";
import AddDream from "./AddDream";
import List from "./List";
// import EditDream from "./EditDream";
import NoonPayment from "./NoonPayment";
import ConsultantsList from "./ConsultantsList";
import Login from "./Login";
import Register from "./Register";
import ButtonAppBar from "./../components/ButtonAppBar";
import { useTranslation } from "react-i18next";
import withRoot from "../withRoot";
import { useTheme } from "@mui/styles";
// import { ContextProvider } from "./context/ContextProvider";
import { Context } from "../context/ContextProvider";
import Home from "./Home";
import HomeList from "./HomeList";
import Cart from "./Cart";
import AddProduct from "./AddProduct";
import DetailItem from "./DetailItem";
// import RouterHome from "./RouterHome";
import OrdersList from "./OrdersList";
import Orders from "./../components/Orders";
import OrdersForUser from "./../components/OrdersForUser";
import OneQuestion from "./../components/OneQuestion";
import Item from "./../components/Item";
// import instance from "./api/api";
import data from "./../api/Data";
import OrdersNaem from "./OrdersNaem";
import Order from "./Order";
import Loading from "./Loading";
import LoginMerchant from "./LoginMerchant";

const RouterHome = () => {
  const theme = useTheme();

  const { t, i18n } = useTranslation();
  const { isLoading, isAdmin, setToken, token, isActive, setIsActive } =
    React.useContext(Context);

  React.useEffect(() => {

    i18n.changeLanguage("ar");
    document.body.dir = i18n.dir();
    theme.direction = i18n.dir();
  }, [theme, i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.body.dir = i18n.dir();
    theme.direction = i18n.dir();
  };
  return (
    <BrowserRouter>
      <ButtonAppBar t={t} i18n={i18n} changeLanguage={changeLanguage} />
      <div
        className="container mt-2"
        style={{ marginTop: 20, backgroundColor: "#F6F6F6" }}
      >
        <Routes>
          <Route exact path="/" element={<Home t={t} i18n={i18n} />} />
          <Route exact path="/home" element={<HomeList t={t} i18n={i18n} />} />
          <Route
            exact
            path="/home/orders/list"
            element={<OrdersList t={t} i18n={i18n} />}
          />
          <Route
            path="/share-app/:user_id/:id"
            element={<ShareApp t={t} i18n={i18n} />}
          />
          <Route
            path="/form-notifications"
            overflow="hidden"
            element={<FormNotifcations />}
          />
          <Route path={`/login`} element={<Login />} />
          <Route path={`/login-merchant`} element={<LoginMerchant />} />
          <Route path={`/register`} element={<Register />} />
          <Route path="/orders" overflow="hidden" element={<Orders />} />
          <Route
            path="/onequestion/:_id"
            overflow="hidden"
            element={<OneQuestion />}
          />
          <Route
            path={`/reset-password/:token`}
            element={<FormResetPassword />}
          />
          <Route
            path={`/get-question-for-user/:user_id`}
            element={<OrdersForUser />}
          />
          <Route
            path={`/successResetPassword`}
            element={<SuccessResetPassword />}
          />
          <Route path={`/SuccessAddDream`} element={<SuccessAddDream />} />
          <Route path={`/promo-dreams-live`} element={<Promo />} />
          <Route path={`/privacy`} element={<Privacy />} />
          <Route path={`/policy`} element={<Policy t={t} />} />
          <Route path="/add-dream" element={<AddDream t={t} />} />
          <Route path="/NoonPayment" element={<NoonPayment />} />
          <Route path="/consultants-list" element={<ConsultantsList />} />
          <Route path="/list" element={<List />} />
          <Route
            path="/add-product"
            element={<AddProduct i18n={i18n} t={t} />}
          />
          <Route path="/checkout" element={<Checkout t={t} i18n={i18n} />} />
          <Route path="/payment" element={<Payment t={t} i18n={i18n} />} />
          <Route path="/:_id" element={<DetailItem t={t} i18n={i18n} />} />
          <Route
            path="/current-order"
            element={<CurrentOrder t={t} i18n={i18n} />}
          />
          <Route
            path="/orders-naem"
            element={<OrdersNaem t={t} i18n={i18n} />}
          />
          <Route path="/order/:id" element={<Order t={t} i18n={i18n} />} />


          <Route
            exact
            path="/cart"
            element={
              localStorage.getItem("Token") == null ? (
                <Navigate to="/login" />
              ) : (
                <Cart t={t} i18n={i18n} />
              )
            }
          />
          <Route path={`/item`} element={<Item />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default withRoot(RouterHome);
